import React from "react";
import { ColorPicker } from "../../../../../../components";
import { FORM_KEYS } from "../../../../constants";

/**
 * @desc Input color for convention form.
 */
export const ColorBackground = (props) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "color-background-error",
  };

  const inputProps = {
    type: "text",
    id: "color-background",
    className: "form-control convention-input",
    "aria-describedby": errorProps.id,
    ...props,
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "BACKGROUND COLOR",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.BACKGROUND_COLOR,
  };

  return <ColorPicker {...parentProps} />;
};
